import React, { Component } from "react";
import Rte from "../atoms/rte";

import "../../scss/organisms/_forms.scss";

class FormContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadLabelValue: "Upload a file ...",
    };
  }

  fileInputChange = (e) => {
    let control = e.currentTarget;

    var fileName = "";
    if (control.files && control.files.length > 1) {
      fileName = (control.getAttribute("data-multiple-caption") || "").replace(
        "{count}",
        control.files.length
      );
    } else {
      fileName = e.target.value.split("\\").pop();
    }

    if (fileName) {
      this.setState({ uploadLabelValue: fileName });
    } else {
      this.setState({ uploadLabelValue: "Upload a file..." });
    }
  };

  render() {
    const dictionary = this.props?.dictionary;
    const formContent = (
      <>
        <div className="fieldset">
          <legend className="d-none">Contact</legend>
          <div className="form-group">
            <label htmlFor="name">{dictionary?.contactNameLabel}</label>
            <input
              type="text"
              className="form-control"
              name="name"
              onChange={(e) => this.props.handleChange(e)}
              required="required"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">{dictionary?.contactEmailLabel}</label>
            <input
              type="text"
              className="form-control"
              name="email"
              onChange={(e) => this.props.handleChange(e)}
              required="required"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">{dictionary?.contactMessageLabel}</label>
            <textarea
              type="text"
              name="message"
              className="form-control"
              onChange={(e) => this.props.handleChange(e)}
              required="required"
            />
          </div>
          <div className="form-group">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text" id="inputGroupFileAddon01">
                  Upload CV
                </span>
              </div>
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="inputGroupFile01"
                  onChange={(e) => {
                    this.fileInputChange(e);
                    this.props.handleFilesSelection(e);
                  }}
                  name="attachement"
                  aria-describedby="inputGroupFileAddon01"
                />
                <label className="custom-file-label" htmlFor="inputGroupFile01">
                  {this.state.uploadLabelValue}
                </label>
              </div>
            </div>
          </div>
          <div className="btn-group">
            <button className="btn btn-primary">
              <span>{dictionary?.contactSubmit}</span>
            </button>
          </div>
        </div>
        <div className="form-footer my-5">
          <div className="row">
            <div className="col-md-6">
              <Rte content={dictionary?.contactDisclaimer} />
            </div>
          </div>
        </div>
      </>
    );

    return (
      <form
        className={["form", this.props.className || ""].join(" ")}
        name="contact"
        method="post"
        data-netlify="true"
        onSubmit={(e) => this.props.submitForm(e)}
      >
        {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
        <input type="hidden" name="form-name" value="contact" />
        {!this.props.formState ? (
          formContent
        ) : this.props.formState === "success" ? (
          <Rte content={dictionary?.contactSuccessMessage} />
        ) : (
          <Rte content={dictionary?.contactErrorMessage} />
        )}
      </form>
    );
  }
}

export default FormContact;
